import React from "react";
import defaultStyles from "./base-chart-component.scss";

export default function BaseChartComponent(props) {
  const { children, styles = {} } = props;
  return (
    <div className={`${defaultStyles.chart} ${styles.chart}`}>{children}</div>
  );
}
